import request from '@/CommonDP/utils/request';
import env from '../utils/env';

export default {
  // 获取企业信息模块接口
  usergetEnterpriseList() {
    return request.get(`/user/getEnterpriseList`).then((res) => res);
  },
  updateCertainEval(params) {
    return request
      .post('/CertainEval/updateCertainEval', params)
      .then((res) => res);
  },
  userselectEnterprise(enterpriseId) {
    return request
      .get(`/user/selectEnterprise?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  getTrialTime() {
    return request.get(`/enterprise/getTrialTime`).then((res) => res);
  },
  getPlugList() {
    return request.get(`/user/getPlugList`);
  },
  getManualList(code) {
    return request.get(`/user/getManualList?uploadType=${code} `);
  },
  downloadUrlone(filePath) {
    return (
      env.VUE_APP_API + `/downloadPlug?filePath=${filePath}`
    );
  },

  refreshEnterpriseStages(enterprise) {
    return request.post(
      `/enterprise/stage/refreshAll?enterpriseId=${encodeURIComponent(
        enterprise
      )}`
    );
  },
  // 获取用户中心企业信息显示权限true显示false不显示
  judgeCanCreateEnterprise() {
    return request.get(`/enterprise/judgeCanCreateEnterprise`);
  },
  // 判断有没有分支机构是否的接口
  judgeBranchOrg(enterpriseId) {
    return request.get(`/org/judgeBranchOrg?enterpriseId=${enterpriseId}`);
  }
};
